var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"van-text-14 text-white",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.is_loading)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }